import { useRef, useEffect } from "react";

export default function useUnmountEffect(fn) {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => () => fnRef.current(), []);
}
